{
  "duration-form": {
    "text": {
      "hour": "Hodina",
      "minute": "Minutka"
    }
  }
}
